import { useState } from 'react';
import { Gauge, ChevronDown, ChevronUp } from 'lucide-react';
import { useTranslation } from '../../context/LanguageContext';
import { getNavToModuleMap } from '../../services/modulesService';
import LimitsOverview from './LimitsOverview';

/**
 * Bandeau « Mon usage » au-dessus de chaque module : profil, abonnement,
 * limites et ce qui est déjà consommé. Replié par défaut ; ne s'affiche que
 * sur la page d'un module (pas sur l'accueil ni les écrans de la plateforme).
 */
const ModuleUsageStrip = ({ currentPage, onSeeAll }) => {
    const { t } = useTranslation();
    const [ouvert, setOuvert] = useState(false);

    const codeModule = getNavToModuleMap()[currentPage];
    if (!codeModule) return null;

    return (
        <div className="mb-3 rounded-xl border border-gray-200 bg-white" data-testid="bandeau-usage">
            <button
                type="button"
                onClick={() => setOuvert((o) => !o)}
                aria-expanded={ouvert}
                className="w-full flex items-center justify-between gap-2 px-4 py-2 min-h-11 sm:min-h-0 text-sm text-gray-700 hover:bg-gray-50 rounded-xl"
            >
                <span className="flex items-center gap-2">
                    <Gauge className="w-4 h-4 text-cabaza-purple" />
                    {t.limitsPage?.myUsage || 'Mon usage'}
                </span>
                {ouvert ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            </button>
            {ouvert && (
                <div className="px-4 pb-4 pt-1 border-t border-gray-100">
                    <LimitsOverview moduleCode={codeModule} onSeeAll={onSeeAll} />
                </div>
            )}
        </div>
    );
};

export default ModuleUsageStrip;
